import { UserJWT } from '@/types/user'

const JWT_EXPIRY_LEEWAY_MS = 30 * 1000

export const isJwtTokenExpired = (decodedToken: Pick<UserJWT, 'exp'>) => {
  return decodedToken.exp * 1000 - JWT_EXPIRY_LEEWAY_MS < Date.now()
}
